module.exports = __webpack_public_path__ + "img/cog.cf5b7a93.svg";